


























import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { IEmployee, IPageParams } from '../../models';
import paginationMixin from '@/mixins/pagintation';
@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'employee',
  }),
  mixins: [paginationMixin],
})
export default class EmployeeList extends Vue {
  @Action('getEntities', { namespace: 'employee' }) getEntities: () => void;
  @Getter('entitiesSlice', { namespace: 'employee' })
  entitiesSlice: IEmployee[];
  @State('pageParams', { namespace: 'employee' }) pageParams: IPageParams;
  selected = [];
  interval = null;
  headers = [
    { text: 'Фамилия', value: 'last_name' },
    { text: 'Имя', value: 'first_name' },
    { text: 'Отчество', value: 'middle_name' },
    { text: 'Почта', value: 'email' },
  ];
  created() {
    this.getEntities();
  }
}
